import styles from "./ApoBankCta.module.css";

export type ApoBankCtaVariant =
  | "studienkredit"
  | "auslandskrankenversicherung"
  | "studierendenpaket";

interface VariantContent {
  image: string;
  /** Headline split around the purple-marked word. */
  headline: { pre: string; mark: string; post: string };
  sub: string;
  href: string;
  buttonLabel: string;
}



// Copy from the apoBank campaign spec (Anzeige). Landing pages live under
// /apo-bank/<slug>/ as static exports — see public/apo-bank/.
const VARIANTS: Record<ApoBankCtaVariant, VariantContent> = {
  studienkredit: {
    image: "/images/apobank/cta-img-1.png",
    headline: { pre: "Die Ibu für Deinen ", mark: "Cashflow", post: "." },
    sub: "Weniger Kopfschmerzen neben dem Studium. Der apoBank-Studienkredit entlastet Dich: verlässlich, schnell, unkompliziert.",
    href: `/apo-bank/studienkredit/?utm_source=ncrechner&utm_medium=blog&utm_campaign=Kredit&utm_content=cta-studienkredit-apobank`,
    buttonLabel: "Jetzt informieren",
  },
  auslandskrankenversicherung: {
    image: "/images/apobank/cta-img-2.png",
    headline: { pre: "Die richtige ", mark: "Behandlung", post: " für Deinen Trip." },
    sub: "Mit uns bist Du safe im Ausland. Bei Famulatur, Auslandssemester und Praktikum.",
    href: `/apo-bank/auslandskrankenversicherung/?utm_source=ncrechner&utm_medium=blog&utm_campaign=ARKV&utm_content=cta-auslandskrankenversicherung-apobank`,
    buttonLabel: "Mehr erfahren",
  },
  studierendenpaket: {
    image: "/images/apobank/cta-img-3.png",
    headline: { pre: "Die beste ", mark: "Therapie", post: " gegen Finanzstress." },
    sub: "Die perfekte Symbiose aus Studium und Banking: kostenloses Konto, Vorteile und Cashmanagement von Anfang an.",
    href: `/apo-bank/studierendenpaket/?utm_source=ncrechner&utm_medium=blog&utm_campaign=Studipaket&utm_content=cta-studierendenpaket-apobank`,
    buttonLabel: "Paket entdecken",
  },
};

interface ApoBankCtaProps {
  variant: ApoBankCtaVariant;
  className?: string;
}

/**
 * apoBank CTA ad block (marked "Anzeige") linking to the apoBank landing
 * pages under /apo-bank/. Design and copy come from the apoBank campaign
 * spec; the block is server-rendered with no client JS.
 */
export default function ApoBankCta({ variant, className = "" }: ApoBankCtaProps) {
  const v = VARIANTS[variant];

  return (
    <aside className={`${styles.block} ${className}`} aria-label="Anzeige: apoBank">
      <div className={styles.visual}>
        <img src={v.image} alt="" className={styles.ctaImg} loading="lazy" />
        <span className={styles.anzeige}>Anzeige</span>
        <span className={styles.coopCorner}>
          <span className={styles.logos}>
            <img
              src="/images/apobank/apo-campus.png"
              alt="apoCampus"
              className={styles.lgCampus}
              loading="lazy"
            />
            <img
              src="/images/apobank/apobank-v1.png"
              alt="apoBank"
              className={styles.lgBank}
              loading="lazy"
            />
          </span>
        </span>
      </div>
      <div className={styles.content}>
        <h3 className={styles.hl}>
          {v.headline.pre}
          <span className={styles.mark}>{v.headline.mark}</span>
          {v.headline.post}
        </h3>
        <p className={styles.sub}>{v.sub}</p>
        <a
          className={styles.ctaBtn}
          href={v.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {v.buttonLabel}
        </a>
      </div>
    </aside>
  );
}
